import styled from "styled-components";

const bp = {
  sm: "480px",
  md: "768px",
  lg: "1024px",
};

export const ContainerApresentation = styled.div`
  position: relative;
  width: 100%;
  height: 93vh;

  background-image: url(${($props) => $props.$bgImage});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;

  background-color: rgba(0, 0, 0, 0.4);
  background-blend-mode: darken;

  padding: env(safe-area-inset-top, 0) env(safe-area-inset-right, 0)
    env(safe-area-inset-bottom, 0) env(safe-area-inset-left, 0);

  @media (max-width: 768px) {
    height: 45vh;
    background-position: center;
  }
`;

export const Apresentation = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center; /* centraliza vertical */
  align-items: center; /* centraliza horizontal */
  text-align: center;
  padding: 0 1rem;

  h1 {
    font-family: "Open Sans", sans-serif;
    font-size: clamp(28px, 7vw, 66px);
    color: #fb4121;
    font-weight: bold;
    margin: 20px 0 0.2em;
    text-shadow: -1px -1px 0px black, 1px -1px 0px black, -1px 1px 0px black,
      1px 1px 0px black;
  }

  h2 {
    font-size: clamp(20px, 4vw, 32px);
    color: white;
    margin: 0;
    text-shadow: -1px -1px 0px black, 1px -1px 0px black, -1px 1px 0px black,
      1px 1px 0px black;
    margin-bottom: 10px;
  }
`;

export const StyledTitleApresentation = styled.h2`
  font-family: "Open Sans", system-ui, -apple-system, Segoe UI, Roboto,
    sans-serif;
  font-style: italic;
  /* Tamanho fluido: 22–45px */
  font-size: clamp(22px, 4vw, 45px);
  line-height: 1.15;
  color: #fff;
  text-shadow: -1px -1px 0px #000, 1px -1px 0px #000, -1px 1px 0px #000,
    1px 1px 0px #000;
  margin: 0;
`;

export const SectionButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  /* Gap fluido */
  gap: clamp(10px, 2.5vw, 24px);

  /* Largura total em mobile, auto em telas maiores pra não forçar overflow */
  width: 100%;
  margin: clamp(8px, 2vw, 16px) 0;

  @media (min-width: ${bp.md}) {
    flex-direction: row;
    width: auto;
    justify-content: center;
  }
`;

export const StyledAnchor = styled.a`
  display: inline-block;
  appearance: none;
  border: 1px solid transparent;
  text-decoration: none;
  outline: none;
  cursor: pointer;

  color: #fff;
  background-color: #1c779f;

  /* Padding e fonte fluidos */
  padding: clamp(10px, 2.4vw, 14px) clamp(16px, 3.2vw, 24px);
  font-size: clamp(14px, 2.3vw, 16px);
  font-weight: 700;
  border-radius: 8px;

  transition: background-color 0.25s ease, color 0.25s ease,
    border-color 0.25s ease, transform 0.08s ease;

  &:hover,
  &:focus-visible {
    background: transparent;
    border-color: #fff;
  }

  &:active {
    transform: translateY(1px);
  }
`;
export const VisuallyHidden = styled.span`
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
`;
